import { create } from "zustand";

import type { VerificationTransfer } from "@/services/yaas/verificationTransfer";

export type MicroTransferConsentRequest = Pick<VerificationTransfer, "recipient" | "lamports">;

interface VerificationConsentState {
    request: MicroTransferConsentRequest | null;
    ask: (request: MicroTransferConsentRequest, signal?: AbortSignal) => Promise<boolean>;
    answer: (accepted: boolean) => void;
}

let pendingAnswer: ((accepted: boolean) => void) | null = null;

export const useVerificationConsentStore = create<VerificationConsentState>((set, get) => ({
    request: null,
    ask: (request, signal): Promise<boolean> => {
        if (signal?.aborted || get().request !== null) return Promise.resolve(false);
        return new Promise<boolean>((resolve) => {
            const abort = (): void => get().answer(false);
            signal?.addEventListener("abort", abort, { once: true });
            pendingAnswer = (accepted): void => {
                signal?.removeEventListener("abort", abort);
                resolve(accepted);
            };
            set({ request });
        });
    },
    answer: (accepted): void => {
        const resolve = pendingAnswer;
        pendingAnswer = null;
        set({ request: null });
        resolve?.(accepted);
    }
}));
